/**
 * Role types that can be assigned colours in the application.
 * Supports attacker roles (melee/ranged), defender roles, and defaults for unknown roles.
 */

/**
 * Returns a colour hex code for the given role, optimised for accessibility.
 *
 * Colour assignments:
 * - Attacker roles: Green (#00C853) - AAA accessibility compliant
 * - Defender role: Pink (#FF4081) - AA accessibility compliant
 * - Unknown/default: Blue-grey (#78909C) - AA accessibility compliant
 *
 * @param role - The role to get a colour for (case-sensitive)
 * @returns Hex colour code string (always 7 characters: # + 6 hex digits)
 *
 * @example
 * roleColour("Attacker") // "#00C853"
 * roleColour("Attacker: Melee") // "#00C853"
 * roleColour("Defender") // "#FF4081"
 * roleColour("Unknown") // "#78909C"
 */
function roleColour(role: string): string {
  if (
    role === "Attacker" ||
    role === "Attacker: Melee" ||
    role === "Attacker: Ranged"
  ) {
    // return "green accent-4" // AAA
    return "#00C853" // AAA
  }
  if (role === "Defender") {
    // return "pink accent-2" // AA
    return "#FF4081" // AA
  }
  // return "blue-grey lighten-1" // AA
  return "#78909C" // AA
}

export { roleColour }
